import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchConsultationTypes,
  createNewConsultationTypes,
  updateConsultationTypesById,
  deleteConsultationTypesById
} from '../../../../redux/actions/consultationActions';

import ModalForms from '../../../../components/ConfirmationModal/ModalForms';
import { useModalFeedback } from '../../../../hooks/useModalFeedback';
import SearchBar from '../../../../components/SearchBar/SearchBar';
import { MdDelete, MdCreate } from 'react-icons/md';
import { FaClipboardCheck, FaMoneyBillWave } from "react-icons/fa";
import LoadingEllipsis from '../../../../components/LoadingEllipsis/LoadingEllipsis';
import CreateConsultationTypes from './CreateConsultationTypes';

import '../../../../Mobile.css';
import '../styles/ConsultationTypes.css';
import Pagination from '../../../../components/Pagination/Pagination';


function ConsultationTypes() {
  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const icoUpdate = <MdCreate className='icon' />;
  const icoTrash = <MdDelete className='icon' />;
  const icoType = <FaClipboardCheck className='mobileIcon' />;
  const icoFee = <FaMoneyBillWave className='mobileIcon' />;
  const [filteredTypes, setFilteredTypes] = useState([]);
  const [, setSearchText] = useState("");

  const {
    showModal,
    message,
    showButtons,
    isDeleting,
    setIsDeleting,
    onConfirm,
    onCancel,
    showConfirmation,
    showInfo,
    hideModal,
  } = useModalFeedback();


  const [editingType, setEditingType] = useState(null);

  const updateBtn = "Editar";
  const deleteBtn = "Deletar";

  const { consultationTypes = [], loading, error } = useSelector((state) => state.consultations);

  useEffect(() => {
    dispatch(fetchConsultationTypes());
  }, [dispatch]);

  useEffect(() => {
    if (consultationTypes && consultationTypes.length) {
      setFilteredTypes(consultationTypes);
    }
  }, [consultationTypes]);

  const handleDelete = (typeId) => {
    const typeName = consultationTypes.find(type => type.consultation_type_id === typeId)?.name || '';
    showConfirmation(
      `Tem certeza que deseja remover o tipo de consulta: ${typeName} ?`,
      () => handleConfirmDelete(typeId), // <- closure com typeId certo
      hideModal
    );
  };

  const handleConfirmDelete = async (typeId) => {
    const typeName = consultationTypes.find(type => type.consultation_type_id === typeId)?.name || '';
    setIsDeleting(true);

    try {
      const response = await dispatch(deleteConsultationTypesById(typeId));

      if (!response.error) {
        showInfo(`${typeName} removido com sucesso!`);
        dispatch(fetchConsultationTypes());
      } else {
        showInfo(`Erro ao tentar deletar: ${response.error}`, 3000);
      }

    } catch (error) {
      showInfo(`Erro ao tentar deletar: ${error.message}`, 3000);
    } finally {
      setIsDeleting(false);
    }
  };


  const handleEdit = (type) => {
    setEditingType(type);
  };

  const handleCreateNew = () => {
    setEditingType({
      name: '',
      default_fee: 0,
      description: ''
    });
  };

  const handleSave = async (typeData) => {
    try {
      if (typeData.consultation_type_id) {
        const { consultation_type_id, name, default_fee, description } = typeData;
        const data = {
          name,
          default_fee: Number(default_fee).toFixed(2),
          description
        };

        await dispatch(updateConsultationTypesById({ consultation_type_id, data }));
        showInfo('Tipo de consulta atualizado com sucesso!');
      } else {
        await dispatch(createNewConsultationTypes(typeData));
        showInfo('Tipo de consulta criado com sucesso!');
      }

      setEditingType(null);
      dispatch(fetchConsultationTypes());
    } catch (error) {
      showInfo(`Erro ao salvar tipo de consulta: ${error.message || error}`, 3000);
    }
  };


  const handleSearch = (searchText) => {
    setSearchText(searchText);
    const filtered = consultationTypes.filter(type =>
      `${type.name || ''} ${type.description || ''} ${type.default_fee || ''}`.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredTypes(filtered);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const getPageButtonClass = (index) => (currentPage === index + 1 ? 'active' : '');

  const paginatedTypes = filteredTypes.slice(indexOfFirstItem, indexOfLastItem);


  return (
    <>
      {showModal && (
        <ModalForms
          message={message}
          onConfirm={onConfirm}
          onCancel={onCancel}
          isDeleting={isDeleting}
          showButtons={showButtons}
        />
      )}

      {editingType ? (
        <CreateConsultationTypes
          type={editingType}
          onSave={handleSave}
          onCancel={() => setEditingType(null)}
        />
      ) : (
        <div className="boxConsultationTypes">
          <h3>Tipos de Consulta</h3>
          <div className="searchAdd">
            <div className="col1">
              <SearchBar onSearch={handleSearch} />
            </div>
            <div className="col2">
              <button className="addBtn" onClick={handleCreateNew}>
                Criar Novo Tipo de Consulta
              </button>
            </div>

          </div>
          <h6>Resultados Retornados: {consultationTypes.length}</h6>
          <table className='consultationTypesTable'>
            <thead>
              <tr>
                <td>Nome</td>
                <td>Valor Padrão</td>
                <td>Descrição</td>
                <td>Ações</td>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <LoadingEllipsis message='Carregando Tipos de Consulta' />
                </tr>
              ) : paginatedTypes.length === 0 ? (
                <tr>
                  <td className="colLine">nenhum registro localizado</td>
                </tr>
              ) : (
                paginatedTypes.map((type) => (
                  <tr key={type.consultation_type_id}>
                    <td>
                      {icoType} {type.name}
                    </td>
                    <td>
                      {icoFee} R$ {type.default_fee.toFixed(2)}
                    </td>
                    <td>{type.description}</td>
                    <td className="actions">
                      <button
                        className='icoBtn'
                        type="button"
                        onClick={() => handleEdit(type)}
                        data-tip={updateBtn}
                      >
                        {icoUpdate}
                      </button>
                      <button
                        className='icoBtn'
                        type="button"
                        onClick={() => handleDelete(type.consultation_type_id)}
                        data-tip={deleteBtn}
                      >
                        {icoTrash}
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {/* Paginação */}
          {consultationTypes.length > 0 && (
            <Pagination totalItems={consultationTypes.length} itemsPerPage={itemsPerPage} currentPage={currentPage} paginate={paginate} />
          )}

        </div>
      )}
    </>
  );
}

export default ConsultationTypes;